import React from 'react';

const Home = () => {
  return (
    <main className="main-content">
      <div className="content-container">
        <h1 className="welcome-title">
          Welcome to <span className="sunking-text">Sunking</span>
        </h1>
        <p className="welcome-description">
          Sun King designs, distributes, installs, and finances solar energy solutions for the 
          1.8 billion people without reliable access to electricity. From cost-effective solar 
          lanterns and home systems that provide entry-level access to electricity to 
          powerful, multi-kilowatt-scale solar systems that offer power equity with the 
          traditional electrical grid, Sun King's products meet diverse power and light needs 
          across Africa and Asia.
        </p>
      </div>
    </main>
  );
};

export default Home;